import { Application } from "@enums/application.enums";
import { Field, Button } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { fieldTypes } from '@constants/constant';
import { optionDirection } from '@enums/comman.enums';
import { REGEX } from '@core/validation';
import { environment } from "@environments/environment";

export const GoogleFontList: { name: string }[] = [
  { name: 'Aboreto' },
  { name: 'Acme' },
  { name: 'Aguafina Script' },
  { name: 'Aladin' },
  { name: 'Alkalami' },
  { name: 'Alkatra' },
  { name: 'Allura' },
  { name: 'Anton' },
  { name: 'Arbutus' },
  { name: 'Atomic Age' },
  { name: 'Audiowide' },
  { name: 'Bagel Fat One' },
  { name: 'Bahiana' },
  { name: 'Bakbak One' },
  { name: 'Bangers' },
  { name: 'Barrio' },
  { name: 'Bebas Neue' },
  { name: 'Belanosima' },
  { name: 'Berkshire Swash' },
  { name: 'Big Shoulders Inline Text' },
  { name: 'Blinker' },
  { name: 'Black Ops One' },
  { name: 'Borel' },
  { name: 'Bowlby One SC' },
  { name: 'Braah One' },
  { name: 'Bruno Ace SC' },
  { name: 'Bubblegum Sans' },
  { name: 'Bungee' },
  { name: 'Bungee Shade' },
  { name: 'Cagliostro' },
  { name: 'Cairo Play' },
  { name: 'Caprasimo' },
  { name: 'Carme' },
  { name: 'Carter One' },
  { name: 'Castoro Titling' },
  { name: 'Cherry Cream Soda' },
  { name: 'Changa One' },
  { name: 'Cinzel Decorative' },
  { name: 'Codystar' },
  { name: 'Concert One' },
  { name: 'Contrail One' },
  { name: 'Courgette' },
  { name: 'Creepster' },
  { name: 'Crimson Pro' },
  { name: 'Denk One' },
  { name: 'DynaPuff' },
  { name: 'Eagle Lake' },
  { name: 'Emilys Candy' },
  { name: 'Encode Sans SC' },
  { name: 'Ephesis' },
  { name: 'Federant' },
  { name: 'Federo' },
  { name: 'Fontdiner Swanky' },
  { name: 'Frijole' },
  { name: 'Gafata' },
  { name: 'Geo' },
  { name: 'Goblin One' },
  { name: 'Grandstander' },
  { name: 'Great Vibes' },
  { name: 'Griffy' },
  { name: 'Gulzar' },
  { name: 'Holtwood One SC' },
  { name: 'IM Fell Great Primer SC' },
  { name: 'Kaushan Script' },
  { name: 'Kablammo' },
  { name: 'Kanit' },
  { name: 'Kavoon' },
  { name: 'Kreon' },
  { name: 'Lacquer' },
  { name: 'Lemon' },
  { name: 'Lexend Deca' },
  { name: 'Libre Baskerville' },
  { name: 'Luckiest Guy' },
  { name: 'Lugrasimo' },
  { name: 'Lumanosimo' },
  { name: 'Macondo Swash Caps' },
  { name: 'Marcellus' },
  { name: 'Marcellus SC' },
  { name: 'Metal Mania' },
  { name: 'Michroma' },
  { name: 'Mina' },
  { name: 'Monofett' },
  { name: 'Monomaniac One' },
  { name: 'Monoton' },
  { name: 'Mooli' },
  { name: 'Mr Dafoe' },
  { name: 'Mogra' },
  { name: 'Mochiy Pop One' },
  { name: 'Noto Sans' },
  { name: 'Nosifer' },
  { name: 'Odor Mean Chey' },
  { name: 'Oleo Script' },
  { name: 'Orbitron' },
  { name: 'Ovo' },
  { name: 'Pacifico' },
  { name: 'Paprika' },
  { name: 'Passero One' },
  { name: 'Passion One' },
  { name: 'Paytone One' },
  { name: 'Peralta' },
  { name: 'Permanent Marker' },
  { name: 'Piedra' },
  { name: 'Potta One' },
  { name: 'Port Lligat Sans' },
  { name: 'Princess Sofia' },
  { name: 'Protest Guerrilla' },
  { name: 'Protest Riot' },
  { name: 'Racing Sans One' },
  { name: 'Rampart One' },
  { name: 'Red Rose' },
  { name: 'REM' },
  { name: 'Reggae One' },
  { name: 'Righteous' },
  { name: 'Risque' },
  { name: 'Rock Salt' },
  { name: 'Roboto' },
  { name: 'Russo One' },
  { name: 'Rubik Distressed' },
  { name: 'Rubik Glitch' },
  { name: 'Rubik Marker Hatch' },
  { name: 'Rubik Moonrocks' },
  { name: 'Rye' },
  { name: 'Sacramento' },
  { name: 'Saira Stencil One' },
  { name: 'Salsa' },
  { name: 'Sancreek' },
  { name: 'Sansita Swashed' },
  { name: 'Sarina' },
  { name: 'Satisfy' },
  { name: 'Shrikhand' },
  { name: 'Shojumaru' },
  { name: 'Sigmar' },
  { name: 'Sigmar One' },
  { name: 'Signika' },
  { name: 'Signika Negative' },
  { name: 'Simonetta' },
  { name: 'Slackey' },
  { name: 'Song Myung' },
  { name: 'Stick' },
  { name: 'Stick No Bills' },
  { name: 'Suez One' },
  { name: 'Syncopate' },
  { name: 'Teko' },
  { name: 'Tilt Warp' },
  { name: 'Timmana' },
  { name: 'Tiro Devanagari Hindi' },
  { name: 'Tourney' },
  { name: 'Trade Winds' },
  { name: 'Train One' },
  { name: 'Tsukimi Rounded' },
  { name: 'Uncial Antiqua' },
  { name: 'Vampiro One' },
  { name: 'Wellfleet' },
  { name: 'Yeon Sung' },
  { name: 'Young Serif' },
  { name: 'Ysabeau' },
  { name: 'Yuji Hentaigana Akari' }
];

export const dataURLToBlob = (dataURL: string): Blob => {
  const parts = dataURL.split(';base64,');
  const byteString = atob(parts[1]);
  const mimeString = parts[0].split(':')[1];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

// Message type for iframe preview communication
export const WLS_PREVIEW_MESSAGE_TYPE = 'WLS_PREVIEW_UPDATE';

export enum WhiteLableSiteEnum {
  DEFAULT_COLOR = '#FF0000',
  WHITELABEL_CUSTOM_LOGO_TYPE = 'nameTitle',
  SETUP_IMAGE_LOGO = 'uploadImage',
  DEFAULT_FONT = 'Roboto',
  UPLOAD_CUSTOM_LOGO = 'Generate Text Logo',
  UPLOAD_IMAGE = 'Upload Logo Image',
  USER_INFO_FOR_CUSTOM_LOGO = '',
  FONT = 'Text Font *',
  ENTER_NAME = 'Logo Text *',
  PREVIEW_CUSTOM_LOGO = 'Preview Text Logo',
  LOGO_FONT = 'Logo Font *',
  WHITELABEL_UPDATE_SUCCESSFUL_MESSAGE = 'White Labeled Site has been updated successfully',
  LOGO_IMAGE_SIZE_CONSTRAINTS = 'Image should be 32px height and at least 32px wide. For optimal results upload a transparent PNG image that is 32px high, and between 32px wide and 335px wide.',
  WHITELABEL_DOMAIN_DESCRIPTION = 'You can have your TopFan site also load on your own private custom domain name (www.creator-name.com), by completing the steps below. TopFan doesn\'t sell custom domain names, but you can get a highly discounted one from our partner at',
  NAMECHEAP_PARTNER_NAME = 'Namecheap',
  PURCHASE_DOMAIN_BEFORE_SETUP = 'Please purchase your domain name before setting up your White Label Site.',
  DOMAIN_OWNERSHIP_NOTE = '(Note: This should be a domain name you already own: www.creator-name.com)',
}

export const LOGO_IMAGE_DIMENSIONS = {
  HEIGHT: 32,
  MIN_WIDTH: 32,
  MAX_WIDTH: 335
} as const;

export const ColorComboErrors = {
  BG_BG_TEXT: 'Page Background Color cannot be the same as the Background Text Color',
  POST_BG_POST_TEXT: 'Post Background Color cannot be the same as the Post Text Color',
  THEME_BUTTON_TEXT: 'Logo & Button Color cannot be the same as the Button Text Color',
  BG_SECONDARY_BG: 'Page Background Color cannot be the same as the Post Background Color'
}

export const WLS_MESSAGES = {
  INVALID_DOMAIN_NAME: 'Invalid domain name. Please check and try again.',
  DOMAIN_VERIFIED_SUCCESS: 'Domain verified successfully!',
  VERIFICATION_FAILED: 'Verification failed. Please check your DNS records and try again.',
  DELETED_SUCCESSFULLY: 'Deleted Successfully',
  UPDATE_AND_PUBLISH_SUCCESS: 'White Label site updated and published successfully',
  PUBLISH_FAILED: 'Failed to publish',
  COMPLETE_DOMAIN_SETUP_FIRST: 'Please complete domain setup first',
  URL_COPIED: 'URL copied to clipboard',
  URL_COPY_FAILED: 'Failed to copy URL',
  DNS_RECORDS_NOT_FOUND: 'DNS records not found'
}

export const WLS_PAGE_LABELS = {
  PAGE_HEADING: 'Setup Your White Label Site',
  ACTIVE_BADGE: 'ACTIVE'
} as const;

export const WLS_VERIFICATION_PENDING_LABELS = {
  STATUS_BADGE: 'VERIFICATION & PROVISIONING IN PROCESS',
  TITLE: 'Your White-Label Site is Being Provisioned',
  SUBTITLE: '',
  ICON_ALT: 'Verification pending',
  DESCRIPTION_PREFIX: 'DNS propagation can take up to',
  DESCRIPTION_HIGHLIGHT: '60 minutes',
  DESCRIPTION_SUFFIX: 'to complete globally. Sit tight - we\'ll automatically verify your records and activate your white-labeled site as soon as everything checks out.',
  MINUTES: 'MINUTES',
  SECONDS: 'SECONDS',
  STEP_ONE: 'Domain submitted successfully',
  STEP_TWO: 'DNS CNAME records configured',
  STEP_THREE: 'Waiting for DNS Propagation and Provisioning',
  STEP_FOUR: 'Site Activated',
  INFO_BANNER: 'You don\'t need to stay on this page - You can safely navigate away and explore other features.',
  ONBOARDING_GUIDE: {
    PREFIX: 'While you wait, we recommend downloading and reviewing our ',
    LINK: 'Onboarding Guide',
    SUFFIX: '.',
    PDF_URL: 'https://cdn-www.topfans.com/pdf/v3/TopFan_Onboarding_Guide.pdf',
    FILE_NAME: 'TopFan_Onboarding_Guide.pdf'
  }
} as const;

export const WLS_DELETE_CONFIRMATION = {
  HEADER: 'Remove White-Label Site',
  MESSAGE: `By clicking Remove below, your white-label site will no longer be available. It may take up to 1 hour for the removal process to complete, at which point you can setup a new white-label site. <br><br> You will need to go to <a href="${environment.original_web_url}" target="_blank">TopFan</a> to setup your new white-label site.`,
  YES: 'Remove',
  NO: 'Cancel'
} as const;


export const WLS_PROVISIONING_COMPLETE_MODAL = {
  HEADER: 'White Label Site Provisioning Complete',
  BODY_PARA_1: 'Now you can setup the Appearance of your White Label Site and then click the "Update & Publish" button.',
  NOTE: 'Note: After you make changes and publish, it can take approximately 1 hour before the changes will appear on your website.',
  LOGIN_INFO_PREFIX: 'Once this final step is done, you will now login to your own site going forward and not through',
  LOGIN_INFO_SUFFIX: 'to access the ability to publish content and monetize with your fans.',
  CONTINUE_BTN: 'Continue',
  SESSION_STORAGE_KEY: 'wls_provisioning_complete_modal_dismissed'
} as const;

export const WLS_APPEARANCE_UPDATING_MODAL = {
  HEADER: 'White Label Site Appearance Updating',
  READY_BY_PREFIX: 'The changes to your white label site will be ready by',
  LOGIN_INFO_PREFIX: 'Going forward, please login to',
  LOGIN_INFO_SUFFIX: 'with the same email and password, where you will be able to further customize your site, publish content and monetize.',
  CUSTOMIZE_INFO: 'By logging into your own website URL, you will be able to further customize your site, publish content and monetize.',
  ONBOARDING_GUIDE_PREFIX: 'Note: We recommend downloading this',
  ONBOARDING_GUIDE_SUFFIX: 'for the next steps',
  VIEW_MY_SITE_BTN: 'View My Site',
  DATE_FORMAT: 'MMM d, yyyy, h:mm a'
} as const;

export const WLS_LOGIN_VIA_SITE_MODAL = {
  HEADER: 'Login Via Your White Label Site',
  BODY_PREFIX: 'You\'ve already setup your white-label site:',
  BODY_INSTRUCTION: 'To access other features, please go directly to your own site URL above and login using the same login and password.',
  NOTE_PREFIX: 'Note:',
  NOTE: 'If you need to change your Website\'s DNS Address, you can delete the settings here by clicking the trash can. You won\'t lose your content, but you will need to setup your white label site from the beginning.',
  GO_TO_MY_SITE_BTN: 'Go To My Site',
  CHANGE_DNS_BTN: 'Edit DNS Details',
  SESSION_STORAGE_KEY: 'wls_login_via_site_modal_dismissed'
} as const;

export const MODAL_RESPONSE = {
  CONFIRM: 'confirm',
  CLOSE: 'close'
} as const;

export const WLS_STEPS = {
  DOMAIN_INFO: 1,
  DNS_RECORDS: 2,
  APPEARANCE: 3
} as const;

export const COLOR_TYPE = {
  BG_COLOR: 'bg_color',
  BG_TEXT_COLOR: 'bg_text_color',
  SECONDARY_BG_COLOR: 'secondary_bg_color',
  POST_TEXT_COLOR: 'post_text_color',
  THEME_COLOR: 'theme_color',
  BUTTON_TEXT_COLOR: 'button_text_color'
} as const;

export const GetFontFamily = (font) => {
  return `https://fonts.googleapis.com/css2?family=${font.replace(/ /g, '+')}&display=swap`;
};

export enum PresetTypeEnum {
  DEFAULT = 'default',
  LIGHT = 'light',
  DARK = 'dark',
  CUSTOM = 'custom'
}

export const DefaultPresetColorCodes = {
  bg_color: Application.DEFAULT_BG_COLOR,
  bg_text_color: Application.DEFAULT_TEXT_COLOR,
  secondary_bg_color: Application.DEFAULT_SECONDARY_BG_COLOR,
  button_text_color: Application.DEFAULT_BUTTON_TEXT_COLOR,
  post_text_color: Application.DEFAULT_TEXT_COLOR,
  theme_color: Application.DEFAULT_PRESET_THEME_COLOR,
} as const;

export const LightPresetColorCodes = {
  bg_color: '#f7f8fa',
  bg_text_color: '#292929',
  secondary_bg_color: '#ffffff',
  button_text_color: '#000000',
  post_text_color: '#292929',
  theme_color: '#09c6da',
} as const;

export const DarkPresetColorCodes = {
  bg_color: '#191a1c',
  bg_text_color: '#ffffff',
  secondary_bg_color: '#000000',
  button_text_color: '#000000',
  post_text_color: '#ffffff',
  theme_color: '#09c6da',
} as const;

export const presetMap = {
  default: DefaultPresetColorCodes,
  light: LightPresetColorCodes,
  dark: DarkPresetColorCodes
}

export const themeKeyMapReverse = {
  [Application.THEME_DEFAULT]: Application.THEME_DEFAULT,
  'theme-light': 'theme-light',
  'theme-dark': 'theme-dark'
};

// ============================================
// WHITELABEL SITE WIZARD CONSTANTS
// ============================================

// URL Preference Enum
export enum UrlPreferenceEnum {
  ROOT_DOMAIN = 'root_domain',
  SUBDOMAIN = 'subdomain'
}

// DNS Providers
export interface DnsProvider {
  id: string;
  name: string;
}

export const DNS_PROVIDERS: DnsProvider[] = [
  { id: 'godaddy', name: 'GoDaddy' },
  { id: 'namecheap', name: 'Namecheap' },
  { id: 'opensrs', name: 'OpenSRS' },
  { id: 'enom', name: 'Enom' },
  { id: 'hover', name: 'Hover' },
  { id: 'onamae', name: 'Onamae.com' },
  { id: 'dynadot', name: 'Dynadot' },
  { id: 'domain_com', name: 'Domain.com' },
  { id: 'network_solutions', name: 'Network Solutions' },
  { id: 'bluehost', name: 'Bluehost' },
  { id: 'register_com', name: 'Register.com' },
  { id: 'squarespace', name: 'Squarespace' },
  { id: 'namesilo', name: 'NameSilo' },
  { id: 'gname', name: 'Gname' },
  { id: 'hostinger', name: 'Hostinger' },
  { id: 'ionos', name: 'IONOS' },
  { id: 'alibaba_cloud', name: 'Alibaba Cloud' },
  { id: 'namebright', name: 'NameBright' },
  { id: 'dropcatch', name: 'DropCatch' },
  { id: 'internet_bs', name: 'Internet.bs' },
  { id: 'moniker', name: 'Moniker' },
  { id: '123reg', name: '123 Reg' },
  { id: 'wix', name: 'Wix' },
  { id: 'ovhcloud', name: 'OVHcloud' },
  { id: 'gandi', name: 'Gandi.net' },
  { id: 'name_com', name: 'Name.com' },
  { id: 'cloudflare', name: 'Cloudflare' },
  { id: 'dreamhost', name: 'DreamHost' },
  { id: 'shopify', name: 'Shopify' },
  { id: 'fasthosts', name: 'Fasthosts' },
  { id: 'united_domains', name: 'United Domains' },
  { id: 'porkbun', name: 'Porkbun' },
  { id: 'other', name: 'Other' },
];

// DNS providers that require forwarding type setup for root domains
export const FORWARDING_TYPE_PROVIDERS: Set<string> = new Set([
  'godaddy',
  'opensrs',
  'hover',
  'onamae',
  'dynadot',
  'domain_com',
  'network_solutions',
  'bluehost',
  'register_com',
  'squarespace',
  'namesilo',
  'gname',
  'hostinger',
  'ionos',
  'alibaba_cloud',
  'namebright',
  'dropcatch',
  '123reg',
  'wix',
  'ovhcloud',
  'dreamhost',
  'shopify',
  'fasthosts',
  'united_domains'
]);

// Step 1 - Domain Information Labels
export const WLS_STEP1_LABELS = {
  STEP_INDICATOR: 'STEP 1 OF 4',
  SECTION_TITLE: 'Domain Information',
  HAS_DOMAIN: 'I already have a Domain Name',
  NO_DOMAIN: "I don't have a Domain Name",
  DNS_PROVIDER_LABEL: 'Domain / DNS Provider',
  DNS_PROVIDER_PLACEHOLDER: 'Select Provider',
  DOMAIN_NAME_LABEL: 'Domain Name',
  DOMAIN_NAME_PLACEHOLDER: 'Enter domain',
  DOMAIN_NAME_INFO: 'Enter your domain without http:// or https://',
  URL_PREFERENCE_LABEL: 'White Label Site URL Preference',
  URL_PREFERENCE_DESCRIPTION: 'How would you like your White Label website address to look to fans?',
  ROOT_DOMAIN_OPTION: '{domain} & www.{domain}',
  SUBDOMAIN_OPTION: 'sub-domain.{domain}',
  SUBDOMAIN_NAME_LABEL: 'Sub-domain Name',
  SUBDOMAIN_NAME_PLACEHOLDER: 'Enter sub-domain',
  NO_DOMAIN_TITLE: 'No domain? No problem.',
  NO_DOMAIN_DESCRIPTION: "To continue, you'll need an active domain.",
  NO_DOMAIN_RECOMMENDATION: 'We recommend Namecheap, which is fully compatible with our tool and offers quick, reliable domain setup.',
  NO_DOMAIN_STEPS_TITLE: 'Follow these steps to get your domain on Namecheap:',
  NO_DOMAIN_STEPS: [
    "Click the button below to open Namecheap's domain page.",
    'Search for your preferred domain name.',
    'Choose an available domain and proceed to checkout.',
    'Complete the payment and finish the domain setup on Namecheap.',
    'Return here and enter your new domain to move forward with the onboarding.'
  ],
  PURCHASE_DOMAIN_BTN: 'PURCHASE DOMAIN ON NAMECHEAP',
  NAMECHEAP_URL: 'https://www.anrdoezrs.net/click-100805719-15018759',
  BACK_BTN: 'BACK',
  SAVE_CONTINUE_BTN: 'SAVE & CONTINUE',
  DNS_PROPAGATION_NOTE: 'Note: This can take up to 60 seconds.'
};

// Step 1 - Field Configurations
export const WLS_STEP1_FIELD_CONFIGS = {
  hasDomainField: {
    type: fieldTypes.RADIO,
    name: 'hasDomain',
    label: '',
    class: '',
    optionDirection: optionDirection.HORIZONTAL,
    options: [
      { label: WLS_STEP1_LABELS.HAS_DOMAIN, value: true },
      { label: WLS_STEP1_LABELS.NO_DOMAIN, value: false }
    ]
  } as Field,

  dnsProviderField: {
    type: fieldTypes.SELECT,
    name: 'dnsProvider',
    label: WLS_STEP1_LABELS.DNS_PROVIDER_LABEL,
    placeholder: WLS_STEP1_LABELS.DNS_PROVIDER_PLACEHOLDER,
    class: '',
    options: DNS_PROVIDERS,
    labelKey: 'name',
    valueKey: 'id',
    validation: {
      required: { message: 'Please select a DNS provider' }
    }
  } as Field,

  domainNameField: {
    type: fieldTypes.TEXT,
    name: 'domainName',
    label: WLS_STEP1_LABELS.DOMAIN_NAME_LABEL,
    placeholder: WLS_STEP1_LABELS.DOMAIN_NAME_PLACEHOLDER,
    class: '',
    infoIconMessage: WLS_STEP1_LABELS.DOMAIN_NAME_INFO,
    validation: {
      required: { message: 'Domain name is required' },
      pattern: {
        value: REGEX.DOMAIN_NAME,
        message: 'Please enter a valid root domain name (e.g., example.com)'
      }
    }
  } as Field,

  subDomainNameField: {
    type: fieldTypes.TEXT,
    name: 'subDomainName',
    label: WLS_STEP1_LABELS.SUBDOMAIN_NAME_LABEL,
    placeholder: WLS_STEP1_LABELS.SUBDOMAIN_NAME_PLACEHOLDER,
    class: '',
    validation: {
      required: { message: 'Subdomain name is required' },
      pattern: {
        value: REGEX.SUBDOMAIN_NAME,
        message: 'Please enter a valid subdomain name'
      }
    }
  } as Field
};

// Step 1 - Button Configurations
export const WLS_STEP1_BUTTON_CONFIGS = {
  backBtn: {
    type: 'button',
    label: WLS_STEP1_LABELS.BACK_BTN,
    class: 'btn',
    name: 'back'
  } as Button,

  continueBtn: {
    type: 'button',
    label: WLS_STEP1_LABELS.SAVE_CONTINUE_BTN,
    class: 'btn btn-primary',
    name: 'continue'
  } as Button,

  purchaseDomainBtn: {
    type: 'button',
    label: WLS_STEP1_LABELS.PURCHASE_DOMAIN_BTN,
    class: 'btn btn-primary purchase-btn',
    name: 'purchaseDomain'
  } as Button
};

// WLS URL Copy Section (shown in step 3 header)
export const WLS_URL_CONFIG = {
  STEP_4_4: 'STEP 4 OF 4',
  URL_LABEL: 'White Label Site URL',
  VIEW_DNS_RECORDS_LINK: 'View DNS Records',
  copyBtn: {
    type: 'button',
    label: 'Copy',
    class: 'btn btn-primary',
    name: 'copy'
  } as Button
};

// Step 2 - DNS Records Labels
export const WLS_STEP2_LABELS = {
  STEP_INDICATOR: 'STEP 2 OF 4',
  SECTION_TITLE: 'Add DNS Records',
  MODAL_TITLE: 'DNS Records',
  SECTION_DESCRIPTION: 'Add these records to your DNS with your provider. Once they are added, click on VERIFY.',
  CNAME_NOTE: 'Note: If there is already a "www" CNAME record, you can edit it or delete and replace it.',
  CNAME_HOST_LABEL: 'CNAME Host #{number}',
  FORWARDING_CNAME_NAME_LABEL: 'CNAME Name #{number}',
  CNAME_VALUE_LABEL: 'Value #{number}',
  FORWARD_HOST_LABEL: 'Forward Host',
  FORWARDING_HOST_LABEL: 'Domain Forwarding (see below)',
  COPY_BTN: 'Copy',
  BACK_BTN: 'BACK',
  VERIFY_CONTINUE_BTN: 'VERIFY & CONTINUE',
  DEFAULT_FORWARD_URL: 'https://www.example.com',
  DNS_PROPAGATION_NOTE_LONG: 'Note: This can take up to 60 seconds.'
};

// Provider-specific setup instructions
export const DNS_PROVIDER_INSTRUCTIONS: { [key: string]: { title: string; steps: { title: string; items: string[] }[] } } = {
  godaddy: {
    title: 'Steps to setup your White-Label Site on GoDaddy',
    steps: [
      {
        title: 'Step 1: Connect domain to hosting or website',
        items: [
          "In GoDaddy, go to your profile → My Products; you'll see both your domain and hosting/Website Builder listed.",
          'Use the "Set up" or "Attach domain" option on hosting/Website Builder, then select your domain; GoDaddy usually links DNS automatically for its own products.'
        ]
      },
      {
        title: 'Step 2: After connecting Setup',
        items: [
          'Install your CMS or builder (WordPress, Webflow, etc.) and publish a page; then check your domain in a browser after DNS updates.',
          "Turn on auto-renew for your domain to avoid losing it and keep WHOIS privacy/protection enabled if it's included."
        ]
      }
    ]
  },
  namecheap: {
    title: 'Steps to setup your White-Label Site on Namecheap',
    steps: [
      {
        title: 'Step 1: Access DNS Settings',
        items: [
          'Log in to your Namecheap account and go to Domain List.',
          'Click "Manage" next to your domain, then select "Advanced DNS" tab.'
        ]
      },
      {
        title: 'Step 2: Add CNAME Records',
        items: [
          'Click "Add New Record" and select CNAME Record type.',
          'Enter the Host and Value from above for each CNAME record.',
          'Save changes and wait for DNS propagation (up to 48 hours).'
        ]
      }
    ]
  },
  cloudflare: {
    title: 'Steps to setup your White-Label Site on Cloudflare',
    steps: [
      {
        title: 'Step 1: Access DNS Settings',
        items: [
          'Log in to Cloudflare and select your domain.',
          'Go to DNS > Records section.'
        ]
      },
      {
        title: 'Step 2: Add CNAME Records',
        items: [
          'Click "Add record" and select CNAME type.',
          'Enter the Name (Host) and Target (Value) from above.',
          'Set Proxy status to "DNS only" (gray cloud) for SSL to work properly.',
          'Save and repeat for all CNAME records.'
        ]
      }
    ]
  },
  other: {
    title: 'Steps to setup your White-Label Site',
    steps: [
      {
        title: 'Step 1: Access Your DNS Settings',
        items: [
          'Log in to your domain registrar or DNS provider.',
          'Navigate to DNS management or DNS settings for your domain.'
        ]
      },
      {
        title: 'Step 2: Add CNAME Records',
        items: [
          'Add each CNAME record using the Host and Value provided above.',
          'Save your changes and allow up to 48 hours for DNS propagation.',
          'Contact your DNS provider support if you need help adding CNAME records.'
        ]
      }
    ]
  }
};

// Domain type specific instructions
export const DNS_INSTRUCTIONS_ROOT_FORWARDING: { title: string; steps: { title: string; items: string[] }[] } = {
  title: 'Steps to setup your White-Label Site (Root Domain with Forwarding)',
  steps: [
    {
      title: 'Step 1: Add CNAME Records',
      items: [
        'Log in to GoDaddy.com',
        'Navigate to (Account > My Products > Domains) DNS settings for your domain.',
        'Add the CNAME records shown above using the Name and Value provided above.'
      ]
    },
    {
      title: 'Step 2: Setup Domain Forwarding',
      items: [
        'Click the Forwarding Tab > Add Forwarding',
        'For the Destination URL, enter {forwardUrl}',
        'Choose the https:// option',
        'Use "Permanent (301)" redirect type.',
        'Save your changes and allow up to 48 hours for DNS propagation.'
      ]
    }
  ]
};

export const DNS_INSTRUCTIONS_ROOT_ALIAS: { title: string; steps: { title: string; items: string[] }[] } = {
  title: 'Steps to setup your White-Label Site (Root Domain with ANAME/ALIAS)',
  steps: [
    {
      title: 'Step 1: Add ANAME/ALIAS Record for Root Domain',
      items: [
        'Log in to your domain registrar or DNS provider.',
        'Navigate to DNS management or DNS settings for your domain.',
        'Add an ANAME or ALIAS record for the root domain (@) using the value provided above.',
        'Note: Some providers call this "ANAME", "ALIAS", or "Flattened CNAME".'
      ]
    },
    {
      title: 'Step 2: Add CNAME Records',
      items: [
        'Add the remaining CNAME records using the Host and Value provided above.',
        'Save your changes and allow up to 48 hours for DNS propagation.'
      ]
    }
  ]
};

export const DNS_INSTRUCTIONS_SUBDOMAIN: { title: string; steps: { title: string; items: string[] }[] } = {
  title: 'Steps to setup your White-Label Site (Subdomain)',
  steps: [
    {
      title: 'Step 1: Access Your DNS Settings',
      items: [
        'Log in to your domain registrar or DNS provider.',
        'Navigate to DNS management or DNS settings for your domain.'
      ]
    },
    {
      title: 'Step 2: Add CNAME Records',
      items: [
        'Add each CNAME record using the Host and Value provided above.',
        'The Host should be your subdomain name (e.g., "shop" for shop.example.com).',
        'Save your changes and allow up to 48 hours for DNS propagation.'
      ]
    }
  ]
};

// Step 3 - Appearance Labels
export const WLS_STEP3_LABELS = {
  STEP_INDICATOR: 'STEP 3 OF 4',
  SECTION_TITLE: 'Customize Appearance',
  WEBSITE_TITLE_TAG_LABEL: 'Website Title Tag',
  WEBSITE_TITLE_TAG_PLACEHOLDER: 'Official Website of Mike Karston',
  G_TAG_LABEL: 'Optional GTM Tag',
  G_TAG_PLACEHOLDER: 'e.g. G-XXXXXXXXXX or GTM-XXXXXXX',
  G_TAG_INFO: 'Hint: This feature allows you to insert an optional tracking tag on all pages on your White-Label Site and mobile apps. To use go to <a class="hyperlink" target="_blank" rel="noopener noreferrer" href="https://tagmanager.google.com/">Google Tag Manager</a> to create a unique GTM tag ID. Google Tag Manager allows you to consolidate tracking codes (pixels) from multiple providers including Google Analytics, Meta, Go High Level and other advertising retargeting providers.',
  SITE_COLORS_TITLE: 'Site Colors & Themes',
  COLOR_PALETTE_LABEL: 'Choose a Color Palette or Theme Type *',
  STANDARD_PALETTES: 'Standard Color Palettes',
  CUSTOM_COLOR: 'Custom Color Palette',
  STANDARD_THEMES: 'Standard Themes',
  CHOOSE_COLOR_PALETTE: 'Choose Color Palette',
  PAGE_BG_COLOR: 'Page Background Color *',
  BG_TEXT_COLOR: 'Background Text Color *',
  POST_BG_COLOR: 'Post Background Color *',
  POST_TEXT_COLOR: 'Post Text Color *',
  LOGO_BUTTON_COLOR: 'Logo & Button Color *',
  BUTTON_TEXT_COLOR: 'Button Text Color *',
  SITE_LOGO_TITLE: 'Site Logo',
  GENERATE_TEXT_LOGO: 'Generate Text Logo',
  UPLOAD_LOGO_IMAGE: 'Upload Logo Image',
  LOGO_TEXT_LABEL: 'Logo Text',
  LOGO_TEXT_PLACEHOLDER: 'Miles Karston',
  LOGO_FONT_LABEL: 'Logo Font *',
  PREVIEW_TEXT_LOGO: 'Preview Text Logo',
  LOGO_IMAGE_RECOMMENDATION: 'Upload a transparent PNG image that is 32px in Height, and between 32px and 335px Wide.',
  LOGO_IMAGE_CROPPER_RECOMMENDATION: 'Recommended size: 32px Tall x between 32px Wide & 335px Wide',
  SELECT_FILE: 'Select File',
  FULL_PREVIEW_BTN: 'DESKTOP PREVIEW OF WHITE LABEL SITE',
  QUICK_PREVIEW_TITLE: 'White Label Site Preview',
  QUICK_PREVIEW_DESCRIPTION: 'Below is how your site will look on Mobile. Click the Desktop Preview button below to see how it will look on full size browsers.',
  BACK_BTN: 'BACK',
  SAVE_BTN: 'Update Settings',
  UPDATE_AND_PUBLISH_BTN: 'Update & Publish',
  PUBLISH_TIME_TEXT: 'Your White Label Site will be updated and published by',
  LOGO_FONT: 'Logo Font'
};

// Color Palette Type Enum - kept for backward compatibility with saved data
export enum ColorPaletteTypeEnum {
  STANDARD = 'Standard',
  CUSTOM = 'Custom',
  THEME = 'Theme'
}

// Quick Preview Mock Data
export const QUICK_PREVIEW_DATA = {
  creatorName: 'Eli Young Band',
  location: 'Nashville, Tennessee, United States',
  bio: 'Triple Spur is an American country music band composed of John Tate (lead vocals, guitar), James Madison (guitar), Jack Tobet (bass guitar), and Danny Hayes (drums). They released their self-titled debut album in 2002 and are based in Nashville Tennesse',
  stats: {
    posts: 876,
    followers: '156,499',
    following: 499,
    awards: 3
  },
  actionButtons: ['STORE', 'CHAT ROOM', 'LEADERBOARDS', 'TOUR', 'FAN OFFERS', 'MUSIC', 'NEWSLETTERS'],
  samplePost: {
    userName: 'Vinnie Walker',
    badge: 'TIKTOK',
    content: 'Help Bring Clean Water to Rural Communities. Millions of people in rural areas lack access to clean drinking water. Together, we can change that! This fundraiser aims to install sustainable water filtration systems in underserved villages.'
  }
};

// Field Configurations
export const META_TAG_FIELD: Field = {
  type: fieldTypes.TEXT,
  name: 'metaTag',
  label: WLS_STEP3_LABELS.WEBSITE_TITLE_TAG_LABEL,
  placeholder: WLS_STEP3_LABELS.WEBSITE_TITLE_TAG_PLACEHOLDER,
  class: ''
};

export const G_TAG_ID_FIELD: Field = {
  type: fieldTypes.TEXT,
  name: 'gTagId',
  label: WLS_STEP3_LABELS.G_TAG_LABEL,
  placeholder: WLS_STEP3_LABELS.G_TAG_PLACEHOLDER,
  class: '',
  infoIconMessage: WLS_STEP3_LABELS.G_TAG_INFO
};

export const COLOR_PALETTE_TYPE_FIELD: Field = {
  type: fieldTypes.SELECT,
  name: 'colorPaletteType',
  label: WLS_STEP3_LABELS.COLOR_PALETTE_LABEL,
  class: '',
  options: [
    { id: ColorPaletteTypeEnum.STANDARD, name: WLS_STEP3_LABELS.STANDARD_PALETTES },
    { id: ColorPaletteTypeEnum.CUSTOM, name: WLS_STEP3_LABELS.CUSTOM_COLOR },
    { id: ColorPaletteTypeEnum.THEME, name: WLS_STEP3_LABELS.STANDARD_THEMES }
  ],
  labelKey: 'name',
  valueKey: 'id'
};

export const LOGO_TYPE_FIELD: Field = {
  type: fieldTypes.RADIO,
  name: 'logoType',
  label: '',
  class: '',
  optionDirection: optionDirection.HORIZONTAL,
  options: [
    { label: WLS_STEP3_LABELS.GENERATE_TEXT_LOGO, value: WhiteLableSiteEnum.WHITELABEL_CUSTOM_LOGO_TYPE },
    { label: WLS_STEP3_LABELS.UPLOAD_LOGO_IMAGE, value: WhiteLableSiteEnum.SETUP_IMAGE_LOGO }
  ]
};

export const USER_TEXT_FIELD: Field = {
  type: fieldTypes.TEXT,
  name: 'user_text',
  label: WLS_STEP3_LABELS.LOGO_TEXT_LABEL,
  placeholder: WLS_STEP3_LABELS.LOGO_TEXT_PLACEHOLDER,
  class: '',
  maxlength: 25,
  validation: {
    required: { message: 'Logo text is required' }
  }
};

export const FONT_FIELD: Field = {
  type: fieldTypes.SELECT,
  name: 'user_font',
  label: WLS_STEP3_LABELS.LOGO_FONT_LABEL,
  class: '',
  options: GoogleFontList,
  labelKey: 'name',
  valueKey: 'name'
};

// Button Configurations
export const FULL_PREVIEW_BUTTON: Button = {
  type: 'button',
  label: WLS_STEP3_LABELS.FULL_PREVIEW_BTN,
  class: 'btn btn-outlined btn-primary btn-full-preview w-100 mb-3'
};

export const BACK_BUTTON: Button = {
  type: 'button',
  label: WLS_STEP3_LABELS.BACK_BTN,
  class: 'btn back-btn'
};

export const DELETE_BUTTON: Button = {
  type: 'button',
  label: 'DELETE',
  class: 'btn back-btn'
};

export const SAVE_BUTTON: Button = {
  type: 'button',
  label: WLS_STEP3_LABELS.SAVE_BTN,
  class: 'btn btn-primary'
};

export const PUBLISH_BUTTON: Button = {
  type: 'button',
  label: 'Publish',
  class: 'btn btn-primary'
};

export const UPDATE_AND_PUBLISH_BUTTON: Button = {
  type: 'button',
  label: WLS_STEP3_LABELS.UPDATE_AND_PUBLISH_BTN,
  class: 'btn btn-primary'
};